import { FC, useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { Loader } from 'shared/components/Loader'
import { IApplicationState } from 'redux/store/store'
import { Redirect } from 'react-router'
import { VestigingEnum } from 'shared/models/Enum'
import { IKlant } from 'shared/models/IKlant'
import { IAfleverafspraakLocatieKoppeling } from 'shared/models/IAfleverafspraakLocatieKoppeling'
import { IOrderType } from 'shared/models/IOrderType'
import { ISearchReference } from 'shared/models/References'
import { AflAdrLosseKopersService } from 'services/AflAdrLosseKopersService'
import SearchKoper from './LosseKoperComponents/SearchKoper'
import CustomerData from './LosseKoperComponents/CustomerData'
import AgreementData, { RowType } from './LosseKoperComponents/AgreementData'
import AgreementActions from './LosseKoperComponents/AgreementActions'
import {
  getPossibleOrderTypesActionCreator,
  ISetPossibleOrderTypesResponseAction,
} from 'redux/store/actions/globalAction'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'

interface IProps {
  globalVestiging: VestigingEnum
  possibleOrderTypes: IOrderType[]
  loadingPossibleOrderTypes: boolean
  getPossibleOrderTypes: () => Promise<ISetPossibleOrderTypesResponseAction>
}

const AflAdrLosseKopersLijst: FC<IProps> = ({
  globalVestiging,
  possibleOrderTypes,
  loadingPossibleOrderTypes,
  getPossibleOrderTypes,
}) => {
  const service = new AflAdrLosseKopersService()

  const searchRef = useRef<ISearchReference>()

  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>()

  const [customer, setCustomer] = useState<IKlant>()
  const [activeRow, setActiveRow] = useState<RowType>()
  const [copyRow, setCopyRow] = useState<IAfleverafspraakLocatieKoppeling>()

  const customerFound = (result: IKlant) => {
    setErrorMessage(null)
    setCustomer(result)
  }

  const refresh = () => {
    searchRef.current.search()
  }

  useEffect(() => {
    getPossibleOrderTypes().then(result => {
      if (!result.success) {
        setErrorMessage(result.errorMessage)
      }
    })
  }, [getPossibleOrderTypes])

  return (
    <>
      {globalVestiging === undefined && <Redirect to='/home' />}
      <h2>Onderhouden Afleveradres Kopers</h2>

      <div>
        {(loading || loadingPossibleOrderTypes) && (
          <div>
            <Loader show={true} />
          </div>
        )}
        <SearchKoper
          ref={searchRef}
          service={service}
          warehouse={globalVestiging}
          onError={setErrorMessage}
          onInputChanged={() => setCustomer(null)}
          onLoading={setLoading}
          onResult={customerFound}
        />
      </div>
      {!!errorMessage && (
        <div className='alert alert-danger maxedbox'>{errorMessage}</div>
      )}
      <div>
        <CustomerData customer={customer} />
        <AgreementData
          customer={customer}
          onRowSelected={setActiveRow}
          copyRow={copyRow}
          possibleOrderTypes={possibleOrderTypes}
        />
        <AgreementActions
          customer={customer}
          service={service}
          warehouse={globalVestiging}
          activeRow={activeRow}
          possibleOrderTypes={possibleOrderTypes}
          onChangeCopy={setCopyRow}
          onError={setErrorMessage}
          onLoading={setLoading}
          onReloadRequired={refresh}
        />
      </div>
    </>
  )
}

const mapStateToProps = (store: IApplicationState) => {
  return {
    globalVestiging: store.globalState.vestiging,
    possibleOrderTypes: store.globalState.possibleGroupLinkOrderTypes,
    loadingPossibleOrderTypes: store.globalState.loadingOrderTypes,
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    getPossibleOrderTypes: () => dispatch(getPossibleOrderTypesActionCreator()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AflAdrLosseKopersLijst)
